"use client";

import { createContext, useCallback, useContext, useMemo, useState } from "react";

import { useOpenWithFocus } from "./use-open-with-focus";

type QuizContextValue = {
  open: boolean;
  source: string | null;
  setOpen: (open: boolean, source?: string) => void;
};

const QuizContext = createContext<QuizContextValue | null>(null);

export function QuizProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpenInner] = useOpenWithFocus(false);
  const [source, setSource] = useState<string | null>(null);

  const setOpen = useCallback(
    (next: boolean, src?: string) => {
      if (next) setSource(src ?? null);
      setOpenInner(next);
    },
    [setOpenInner],
  );

  const value = useMemo(() => ({ open, source, setOpen }), [open, source, setOpen]);
  return <QuizContext.Provider value={value}>{children}</QuizContext.Provider>;
}

export function useQuiz() {
  const ctx = useContext(QuizContext);
  if (!ctx) throw new Error("useQuiz must be used inside QuizProvider");
  return ctx;
}
